import BackendService from './BackendService';

export default class UserService {
  static getUsers(dealerId) {
    const params = {
      dealerId,
      page: 1,
      perPage: 1000,
    };
    return BackendService.get('/users/all', { params });
  }

  static getEmployees() {
    return BackendService.get('/employees/all');
  }

  static getUsersForExport(userType) {
    const params = {
      userType,
    };
    return BackendService.get('/employees/export', { params });
  }

  static getUser(userId) {
    return BackendService.get(`/users/${userId}`);
  }

  static getDealers() {
    return BackendService.get('/users/dealers');
  }

  static createUser(user) {
    return BackendService.post('/users', { body: user });
  }

  static createEmployee(employee) {
    return BackendService.post('/employees', { body: employee });
  }

  static updateUser(user) {
    return BackendService.put(`/users/${user.id}`, { body: user });
  }

  static updateUserDealers(user, dealers) {
    return BackendService.put(`/users/${user.id}/dealers`, {
      body: dealers,
      responseType: 'text',
    });
  }

  static updateUserPassword(user) {
    return BackendService.put('/users/changepassword', {
      body: { email: user.email, newPassword: user.password },
    });
  }

  static updateEmployeePassword(user) {
    return BackendService.put('/employees/changepassword', {
      body: { email: user.email, newPassword: user.password },
    });
  }

  static deleteUser(userId) {
    return BackendService.delete(`/users/${userId}`, {
      responseType: 'text',
    });
  }

  static getCRMEntries(dealerId) {
    const params = { dealerId };
    return BackendService.get('/users/crm-entries', { params });
  }

  static unlockUser(userId) {
    return BackendService.post('/users/unlock', {
      body: { id: userId },
    });
  }
}
